import {
  AisWebsocketTokenResponse,
  AisWebsocketUrlResponse,
} from '../../models/vessels/internal-ais-api.model';
import { wrapRequest } from '../base';

/**
 * Get a JWT token for AIS API requests, via the backend proxy.
 *
 * These can only be used once each, don't try to use the same one several times - it won't work.
 *
 * @param callerFeature - Name of the calling feature, for logging and monitoring purposes.
 * @returns AisWebsocketTokenResponse
 */
export const getAisWebsocketToken = async ({
  callerFeature,
}: {
  callerFeature: string;
}): Promise<AisWebsocketTokenResponse> =>
  wrapRequest<AisWebsocketTokenResponse>(
    'post',
    'north_standard',
    '/ais-proxy',
    {
      headers: { 'x-caller-feature': callerFeature },
      body: { endpoint: 'token' },
    }
  );

export const getAisWebsocketUrl = async (): Promise<AisWebsocketUrlResponse> =>
  wrapRequest<AisWebsocketUrlResponse>(
    'get',
    'north_standard',
    '/ais-ws-url',
    {}
  );
